import { render, staticRenderFns } from "./PeriodManagementSetting.vue?vue&type=template&id=1c5628c8&"
import script from "./PeriodManagementSetting.vue?vue&type=script&lang=js&"
export * from "./PeriodManagementSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports